import InputView from './InputView';

import './input-view.css';


export default InputView;
